import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import BlogDetails from './components/BlogComponents/BlogDetails';
import Header from './components/BlogComponents/Header';
import LandingPage from './components/LandingPage';
import Footer from './components/BlogComponents/Footer';
import CategoryListPage from './components/BlogComponents/CategoryListPage';
import LoginPage from './components/auth/LoginPage';
import SignupPage from './components/auth/SignupPage';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import CategoryPage from './components/CategoryListPage';
import { AuthProvider } from './components/AuthContext';
import PrivateRoute from './components/auth/PrivateRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" />
        <Header />
        <Routes>
          {/* <Route
            path="/"
            element={
              <PrivateRoute>
                <LandingPage />
              </PrivateRoute>
            }
          /> */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/:slug" element={<BlogDetails />} />
          <Route path="/category" element={<CategoryListPage />} />
          <Route path="/category/:category" element={<CategoryPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
        <Footer />
      </Router>
    </AuthProvider>
  );
}

export default App;